"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ApplicantResumeWebView_1 = require("./ApplicantResumeWebView");
exports.default = ApplicantResumeWebView_1.ApplicantResumeWebView;
